import React from "react";
import { useScreenSize } from "hooks";
import DesktopInvoiceHistory from "./desktop";
import MobileInvoiceHistory from "./mobile";

export default function InvoiceHistory() {
  const { isDesktop, isMobile, isTablet } = useScreenSize();

  let InvoiceHistoryContainer;

  switch (true) {
    case isDesktop:
      InvoiceHistoryContainer = <DesktopInvoiceHistory />;
      break;
    case isTablet:
      InvoiceHistoryContainer = <DesktopInvoiceHistory />;
      break;
    case isMobile:
      InvoiceHistoryContainer = <MobileInvoiceHistory />;
      break;
    default:
      InvoiceHistoryContainer = <div></div>;
  }

  return InvoiceHistoryContainer;
}
